import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { CallCostDetailSaveEvent } from '../models/call-cost-detail-form-submit-event';
import { GetProviderCallRateDetail_providerCallRate } from '../queries/generated/GetProviderCallRateDetail';
import { SaveProviderCallRate } from '../queries/generated/SaveProviderCallRate';

export const callCostDetailLoad = createAction('[Call Cost Detail] Load');

export const callCostDetailCancel = createAction('[Call Cost Detail] Cancel');

export const callCostDetailAccessDenied = createAction('[Call Cost Detail] Access Denied');

export const loadCallCostDetailSuccess = createAction(
   '[API] Load Call Cost Success',
   props<{ data: GetProviderCallRateDetail_providerCallRate }>()
);

export const updateCallCostId = createAction('[Call Cost Detail] Update Call Cost Id', props<{ callCostId: number }>());

export const deleteCallCost = createAction(
   '[Call Cost Detail] Delete Call Cost',
   props<{ providerCallRateId: number; destination: string | null }>()
);

export const deleteCallCostSuccess = createAction(
   '[Call Cost Detail] Delete Call Cost Success',
   props<{ providerCallRateId: number; destination: string | null }>()
);

export const deleteCallCostFailure = createAction(
   '[Call Cost Detail] Delete Call Cost Failure',
   props<SingleGraphError>()
);

export const deleteCallCostDetailFailure = createAction(
   '[Call Cost Detail] Delete Call Cost Details Failure',
   props<SingleGraphError>()
);

export const loadCallCostDetailFailure = createAction('[API] Load Call Cost Failure', props<SingleGraphError>());

export const saveCallCostDetail = createAction('[Call Cost Detail] Save', props<CallCostDetailSaveEvent>());

export const saveCallCostDetailSuccess = createAction(
   '[Call Cost Detail] Save Success',
   props<{ data: SaveProviderCallRate }>()
);

export const saveCallCostDetailFailure = createAction('[Call Cost Detail] Save Failure', props<SingleGraphError>());

export const loadPageNoCallCost = createAction('[Call Cost Detail] Load Page No Call Cost');
